// extracted by mini-css-extract-plugin
module.exports = {"list":"orders-list_list__1o3z1","link":"orders-list_link__1jT9p","wide":"orders-list_wide__111q5","wideLink":"orders-list_wideLink__20AZ2"};